<div class="landing-page-contianer">
    <div class="logo">
        <img
            alt="Uniqode"
            class="logo-img"
            src="/logo/uniqode-header-logo.svg"
        />
    </div>

    <div class="share-container">
        <div class="welcome-text" style="text-align: center">
            <span class="welcome"> Get the Uniqode Cards app </span>
        </div>

        <div
            class="w-100 d-flex justify-content-center align-items-center mt-3"
        >
            <span class="share-text">
                Everything lives in the app now. Install it to view, share,
                and manage your digital business cards on the go.
            </span>
        </div>

        <div
            class="img-container d-flex justify-content-center align-items-center"
        >
            <div class="qr-container p-4 d-flex">
                <div class="qr-box d-flex flex-column h-100">
                    <span class="scan-text"> Scan to download </span>
                    <img
                        alt="QR code"
                        class="qr-img h-100"
                        src="/img/cards-app-redirect-qr.svg"
                    />
                </div>
            </div>
            <div class="dbc-gif-container">
                <img
                    alt="Landing page gif"
                    class="landing-pwa"
                    src="img/pwa-landing-page.png"
                />
            </div>
        </div>
    </div>
</div>
